<template>
  <div class="help-con">
    <div class="top-title">蚂蚁报信APP使用指引文档</div>
    <h4 class="title">一、 入驻知识付费商城</h4>

    <div class="titl-2"  @click="sub101=!sub101">
      <span class="text">(1)、申请入驻</span>
      <span class="right" :class="{active: sub101}"></span>
    </div>
    <div class="sub" v-show="sub101">
      <div class="sub-text">入驻流程</div>
      <div class="sub-con">
        <div class="text">申请入驻免费，操作流程可在手机内完成。下载APP后，选择手机or微信号注册登录根据界面提示完成认证才可开设知识店铺，认证需要上传姓名、手持身份证正反两面拍照，企业店铺需要上传企业营业执照，资料填充后点击提交即可，审核通过上传知识付费商品。</div>
        <div class="img-con">
          <img class="img" src="../../assets/help/1-01.png" alt="">
        </div>
        <div class="img-con">
          <img class="img" src="../../assets/help/1-02.png" alt="">
        </div>
      </div>

      <div class="sub-text">身份证要求</div>
      <div class="sub-con">
        <div class="text">申请入驻时上传身份信息照片需要确保以下四点：</div>
        <div class="text">1.确保身份证上的信息没有被遮挡。</div>
        <div class="text">2.避免证件与头部重叠。</div>
        <div class="text">3.确保身份证内容完整清晰可见。</div>
        <div class="text">4.照片请勿反拍（请勿使用手机前置摄像头镜像模式拍照）</div>
      </div>

      <div class="sub-text">店铺名称要求</div>
      <div class="sub-con">
        <div class="text">1.店铺名称字数控制在9字以内。</div>
        <div class="text">2.机构名称需体现企业名称关键字。</div>
        <div class="text">3.机构名称和机构logo名称需与营业执照名称一致或有机构名称的关键字，如有商标注  册权需提供商标注册权（暂不支持商标受理证明）</div>
      </div>

      <div class="sub-text">如何收费</div>
      <div class="sub-con">
        <div class="text">开第一个店铺首年免除全额的服务费，开第二个店铺及两个以上店铺时。每个店铺需支付399/年服务费。平台上的店铺的交易额将扣除10%的平台分成。</div>
        <div class="img-con">
          <img class="img" src="../../assets/help/1-03.png" alt="">
        </div>
        <div class="img-con">
          <img class="img" src="../../assets/help/1-04.png" alt="">
        </div>
      </div>
    </div>

    <div class="titl-2"  @click="sub102=!sub102">
      <span class="text">(2)、发布课程</span>
      <span class="right" :class="{active: sub102}"></span>
    </div>
    <div class="sub" v-show="sub102">
      <div class="sub-text">如何开课</div>
      <div class="sub-con">
        <div class="text">注册并认证之后，进入"我的"-"云店管家"-"内容管理"-"创建新课",进行课程创建。课程创建类型分两类，专栏和课程，专栏适用于包含多小节课程或者需要不定时更新的课程，课程则适用于仅包含一小节内容的单课程。</div>
        <div class="img-con">
          <img class="img" src="../../assets/help/1-05.png" alt="">
        </div>
        <div class="img-con">
          <img class="img" src="../../assets/help/1-06.png" alt="">
        </div>
      </div>
      <div class="sub-text">支持课程类型</div>
      <div class="sub-con">
        <div class="text">无论是单课程还是专栏，课程类型均可选择三种：音频、视频和直播。音频和视频为常见的课程类型，根据提示上传课程名称、课程封面图、音频或视频文件上传即可。</div>
        <div class="img-con">
          <img class="img" src="../../assets/help/1-07.png" alt="">
        </div>
        <div class="img-con">
          <img class="img" src="../../assets/help/1-08.png" alt="">
        </div>
        <div class="img-con">
          <img class="img" src="../../assets/help/1-09.png" alt="">
        </div>
      </div>
      <div class="sub-text">安排直播课</div>
      <div class="sub-con">
        <div class="text">直播课可安排在已设置专栏中、或新开专栏、新开单课程中，老师需在开播前五分钟进入直播间，准时开播。直播类型可选择图文、音频和视频直播。如何开直播课？</div>
        <div class="img-con">
          <img class="img" src="../../assets/help/1-10.png" alt="">
        </div>
        <div class="img-con">
          <img class="img" src="../../assets/help/1-11.png" alt="">
        </div>
      </div>
      <div class="sub-text">直播课程管理</div>
      <div class="sub-con">
        <div class="text">直播课可安排在已设置专栏中、或新开专栏、新开单课程中，老师需在开播前五分钟进入直播间，准时开播。直播类型可选择图文、音频和视频直播。如何开直播课？</div>
        <div class="img-con">
          <img class="img" src="../../assets/help/1-12.png" alt="">
        </div>
        <div class="img-con">
          <img class="img" src="../../assets/help/1-13.png" alt="">
        </div>
        <div class="img-con">
          <img class="img" src="../../assets/help/1-14.png" alt="">
        </div>
      </div>
    </div>

    <div class="titl-2"  @click="sub103=!sub103">
      <span class="text">(3)、店主&管理员权限</span>
      <span class="right" :class="{active: sub103}"></span>
    </div>
    <div class="sub" v-show="sub103">
      <div class="sub-text">店主的权限</div>
      <div class="sub-con">
        <div class="text">店主即为该店铺的注册人，拥有该店铺的所有管理权限，包括账号登录、修改账号密码、商品上下架、价格修改，支付密码修改、余额提现等权限。账户绑定的身份证必须是注册人本人的身份证，绑定的必须是本人的银行卡，用于每月提现和打款。绑定的银行卡非注册人名下的银行卡时将影响最后的打款。</div>
      </div>
      <div class="sub-text">管理员的权限（上线中）</div>
      <div class="sub-con">
        <div class="text">店铺的日常打理者，除了部分有关结算的权限，比如修改支付密码、银行账户绑定、提现等权限没有之外，其他权限均享有。</div>
      </div>
    </div>

    <div class="titl-2"  @click="sub104=!sub104">
      <span class="text">(4)、蚂蚁钱包</span>
      <span class="right" :class="{active: sub104}"></span>
    </div>
    <div class="sub" v-show="sub104">
      <div class="sub-text">钱包</div>
      <div class="sub-con">
        <div class="text">钱包分为两处，一个位于【我的】界面，此处钱包是该账号所有流水的汇总；</div>
        <div class="text">第二个位置位于【云店管家】中的【云店钱包】，用于统计云店中的流水汇总。【钱包】和【点卡】，学员的账户余额和商家售出商品的结算金额（扣除平台服务费10%以及其他费用）显示为总资产，余额可申请提现；</div>
        <div class="img-con">
          <img class="img" src="../../assets/help/1-15.png" alt="">
        </div>
      </div>
      <div class="sub-text">点卡</div>
      <div class="sub-con">
        <div class="text">【点卡】是用于直播课开课使用，蚂蚁报信平台直播需充值直播流量才能开启直播，充值金额最低为1元，直播1小时消耗流量费约等于0.2元，建议商家初次充值5元以内即可。</div>
        <div class="img-con">
          <img class="img" src="../../assets/help/1-16.png" alt="">
        </div>
      </div>
    </div>

    <div class="titl-2"  @click="sub105=!sub105">
      <span class="text">(5)、支付结算相关</span>
      <span class="right" :class="{active: sub105}"></span>
    </div>
    <div class="sub" v-show="sub105">
      <div class="sub-text">支付</div>
      <div class="sub-con">
        <div class="text">支付渠道分安卓和苹果，安卓手机支付的方式有三种，蚂蚁账户余额、微信支付和支付宝，蚂蚁账户余额可通过微信或支付宝充值。苹果手机中商城的商品价格显示为蚂蚁金币，蚂蚁金币：人民币兑换比例为：10蚂蚁金币=1元人民币，即10元的商品，标价为100蚂蚁金币。</div>
      </div>
      <div class="sub-text">提现</div>
      <div class="sub-con">
        <div class="text">每月20日可后台申请提现，款项到账时间为提现后2-3个工作日内到账，具体到账时间视银行最终结算时间为准。</div>
      </div>
      <div class="sub-text">退款</div>
      <div class="sub-con">
        <div class="text">机构上传课程中可选择允许学员退款的条件，退款流程参照后台退款系统。机构侧有退款按钮，学员侧</div>
      </div>
      <div class="sub-text">结算</div>
      <div class="sub-con">
        <div class="text">平台上店铺的总交易额将扣除10%的平台分成后（上架IOS课程苹果收取一定比例服务费未计算入内），再结算到店主账户，结算周期为每月1次，固定时间提现并到账绑定的银行卡。</div>
      </div>
    </div>


    <h4 class="title" @click="sub2=!sub2">
      <span class="text">二、使用社群工具</span>
      <span class="right" :class="{active: sub2}"></span>
    </h4>
    <div v-show="sub2">
      <div class="sub">
        <div class="sub-text">基本功能</div>
        <div class="sub-con">
          <div class="text">位置位于【报信】，有添加好友、组建群组、创建社群等功能。</div>
        </div>
      </div>
      <div class="sub">
        <div class="sub-text">群组</div>
        <div class="sub-con">
          <div class="text">社群和群组的区别在于，社群形同我们一般的QQ群和微信群，用于日常沟通交流</div>
        </div>
      </div>
      <div class="sub">
        <div class="sub-text">社群</div>
        <div class="sub-con">
          <div class="text">社群是多个群组的组合体，可将多个不同的群组组成大社群，统一管理所有社群成员。群主通过橙色按钮发送的任何消息，将实时同步到社群中的每一个群组。使用场景：给全群组学员日常交流答疑，发布课程相关通知或公告直播时间等</div>
          <div class="img-con">
            <img class="img" src="../../assets/help/2-01.png" alt="">
          </div>
          <div class="img-con">
            <img class="img" src="../../assets/help/2-02.png" alt="">
          </div>
        </div>
      </div>
      <div class="sub">
        <div class="sub-text">社群直播</div>
        <div class="sub-con">
          <div class="text">社群中还可以发起直播，社群中的所有群组成员均可在线参与直播互动。社群直播发起人只有群主和管理员，除此之外的其他角色没有发起直播的权限。社群直播设置方法：</div>
          <div class="img-con">
            <img class="img" src="../../assets/help/2-03.png" alt="">
          </div>
          <div class="img-con">
            <img class="img" src="../../assets/help/2-04.png" alt="">
          </div>
          <div class="img-con">
            <img class="img" src="../../assets/help/2-05.png" alt="">
          </div>
          <div class="img-con">
            <img class="img" src="../../assets/help/2-06.png" alt="">
          </div>
          <div class="img-con">
            <img class="img" src="../../assets/help/2-07.png" alt="">
          </div>
        </div>
      </div>
      <div class="sub">
        <div class="sub-text">群主和管理员的区别</div>
        <div class="sub-con">
          <div class="text">橙色标识为群主，蓝色标识为管理员角色。</div>
          <div class="img-con">
            <img class="img" src="../../assets/help/2-08.png" alt="">
          </div>
        </div>
      </div>
      <div class="sub">
        <div class="sub-text">设置群主和管理员</div>
        <div class="sub-con">
          <div class="img-con">
            <img class="img" src="../../assets/help/2-09.png" alt="">
          </div>
        </div>
      </div>
      <div class="sub">
        <div class="sub-text">消息标记</div>
        <div class="sub-con">
          <div class="text">标记【重要消息】和【稍后回复】。接收的所有消息都可以标记为【重要消息】或【稍后回复】，帮助避免遗漏信息，及时回复。在任意普通消息对话框左滑即出现标注信息，可对所选择的消息进行相应的标注。</div>
          <div class="img-con">
            <img class="img" src="../../assets/help/2-10.png" alt="">
          </div>
          <div class="img-con">
            <img class="img" src="../../assets/help/2-11.png" alt="">
          </div>
        </div>
      </div>
    </div>

    <h4 class="title" @click="sub3=!sub3">
      <span class="text">三、常见问题汇总（持续更新）</span>
      <span class="right" :class="{active: sub3}"></span>
    </h4>
    <div class="sub" v-show="sub3">
      <div class="sub-text">如何邀请好友下载APP？</div>
      <div class="sub-con">
        <div class="text">D：【我的】-【会员俱乐部】-【邀请好友】</div>
      </div>
      <div class="sub-text">怎么修改店铺名称和头像？</div>
      <div class="sub-con">
        <div class="text">D：【我的】-点击头像进行更换</div>
      </div>
      <div class="sub-text">邀请码是否可以更改？</div>
      <div class="sub-con">
        <div class="text">D：不可以，邀请码注册后已固定，不可更改</div>
      </div>
      <div class="sub-text">如何设置免费试学？</div>
      <div class="sub-con">
        <div class="text">D：在安排课程中，设置课程价格为0，既能实现免费试学课程</div>
      </div>
      <div class="sub-text">上传视频限制？</div>
      <div class="sub-con">
        <div class="text">D：上传视频大小上限为1G，大于1G的视频暂不支持上传；单个账号每天上传视频个数无上限</div>
      </div>
      <div class="sub-text">如何查学员的联系方式呢？</div>
      <div class="sub-con">
        <div class="text">D：【云店管家】-【今日数据】-【新增订单】</div>
      </div>
      <div class="sub-text">如何查询每日订单数据？</div>
      <div class="sub-con">
        <div class="text">D:【我的】-【今日数据】，可以查看今日成交金额、商品总数、新增订单、店铺新增粉丝等数据。</div>
      </div>
      <div class="sub-text">如何开发票？</div>
      <div class="sub-con">
        <div class="text">D：申请开具专票的机构必须填写票面地址，纳税人识别号，票面电话。若未完善信息，我司默认不会邮件发票，请未完善的机构在后台补充，悉知。最后开具的金额：根据总金额给乙方开具6%增值税发票。</div>
      </div>
      <div class="sub-text">搜索排名</div>
      <div class="sub-con">
        <div class="text">D：统一综合课程到课率、完成度、好评度数据。</div>
        <div class="text">1、用户报名后是否愿意一直持续学习</div>
        <div class="text">2、用户评价、投诉情况，总成交量，日流水情况等</div>
      </div>
      <div class="sub-text">课程如何上首页？</div>
      <div class="sub-con">
        <div class="text">D：平台首页展位是平台从全部课程到课率完成度好评度等数据综合评估优质课程机构，工作人员将会主动联系提供资源扶持，暂时不支持机构主动申请。</div>
      </div>
      <div class="sub-text">管理员的数量有没有人数限制？</div>
      <div class="sub-con">
        <div class="text">D：管理员数量无限制</div>
      </div>
      <div class="sub-text"> 怎么加入热门社群？</div>
      <div class="sub-con">
        <div class="text">D：【发现】-【热门社群】-输入名称或选择群组-申请加入</div>
      </div>
      <div class="sub-text">社群或群组如何更改群名字？</div>
      <div class="sub-con">
        <div class="text">D：点击群右上角-社群名称-点击修改</div>
      </div>
      <div class="sub-text">创建的社群是否可以选择公开或隐秘？</div>
      <div class="sub-con">
        <div class="text">D：可以</div>
      </div>
      <div class="sub-text">消息显示右边蓝色图标？</div>
      <div class="sub-con">
        <div class="text">D：你的角色为该群的管理员</div>
      </div>
      <div class="sub-text">消息显示右边橙色图标？</div>
      <div class="sub-con">
        <div class="text">D：你的角色为该群的群主</div>
      </div>
      <div class="sub-text">怎么查看并加入好友创建的社群？</div>
      <div class="sub-con">
        <div class="text">D：【报信】-右上角搜索好友名称可查看好友加入的群聊</div>
      </div>
    </div>

    <div class="footer">
      <div class="qr-con"><img class="code-img" src="../../assets/wx.anttalk.vip.png" alt=""></div>
      <div class="text-con">
        <div class="text">扫码直接下载APP</div>
        <div class="text">蚂蚁微信号：anttalk</div>
        <div class="text">联系电话：400-883-5650</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      sub101: false,
      sub102: false,
      sub103: false,
      sub104: false,
      sub105: false,
      sub2: false,
      sub3: false,
    }
  },
  created(){
    document.getElementsByTagName('html')[0].classList.add('bg-f4')
  },
  destroyed(){
    document.getElementsByTagName('html')[0].classList.remove('bg-f4')
  }
}
</script>

<style lang="less" scoped>
@media all and (max-width: 799px) {
  @size: 1;
  .help-con{
    background-color: #f4f4f4;
    font-size: 14px/@size;
    padding: 12px/@size;
    .top-title{
      text-align: center;line-height: 30px/@size;font-size: 18px/@size;font-weight: bold;
    }
    .img-con{
      padding: 12px/@size 0;
      .img{display: block;min-width: 80%;max-width: 100%;margin: 0 auto;}
    }
    .title{
      font-size: 16px/@size;height: 44px/@size;width: 100%;display: flex;align-items: center;
      .text{flex: 1;}
      .right{
        display: inline-flex;width: 33px/@size;height: 33px/@size;
        background: url("../../assets/help/right.png") no-repeat 50% 50%;background-size: 16px/@size 16px/@size;
        &.active{
          transform: rotate(90deg);
        }
      }
    }
    .titl-2{
      font-size: 14px/@size;font-weight: bold;height: 36px/@size;display: flex;align-items: center;
      .text{flex: 1;}
      .right{
        display: inline-flex;width: 33px/@size;height: 33px/@size;
        background: url("../../assets/help/right.png") no-repeat 50% 50%;background-size: 16px/@size 16px/@size;
        &.active{
          transform: rotate(90deg);
        }
      }
    }
    .sub{
      .sub-text{
        font-size: 12px/@size;font-weight: bold;padding: 4px/@size 0 4px/@size 4px/@size;
      }
      .sub-con{
        padding-bottom: 6px/@size;
        .text{
          padding-left: 12px/@size;
        }
      }
    }
    .footer{
      padding: 24px/@size 0;
      text-align: center;
      font-size: 14px/@size;
      .qr-con{
        width: 100%;
        .code-img{
          display: block;
          width: 160px/@size;
          margin: 0 auto;
        }
      }
      .text-con{
        padding: 24px/@size 0 0 0;
      }
    }
  }
}
@media all and (min-width: 800px) { // 80 / 37.5 = 2.1333
  @size: 2.13333;
  .help-con{
    background-color: #f4f4f4;
    font-size: 14px/@size;
    padding: 12px/@size;
    .top-title{
      text-align: center;line-height: 30px/@size;font-size: 18px/@size;font-weight: bold;
    }
    .img-con{
      padding: 12px/@size 0;
      .img{display: block;min-width: 80%;max-width: 100%;margin: 0 auto;}
    }
    .title{
      font-size: 16px/@size;height: 44px/@size;width: 100%;display: flex;align-items: center;
      .text{flex: 1;}
      .right{
        display: inline-flex;width: 33px/@size;height: 33px/@size;
        background: url("../../assets/help/right.png") no-repeat 50% 50%;background-size: 16px/@size 16px/@size;
        &.active{
          transform: rotate(90deg);
        }
      }
    }
    .titl-2{
      font-size: 14px/@size;font-weight: bold;height: 36px/@size;display: flex;align-items: center;
      .text{flex: 1;}
      .right{
        display: inline-flex;width: 33px/@size;height: 33px/@size;
        background: url("../../assets/help/right.png") no-repeat 50% 50%;background-size: 16px/@size 16px/@size;
        &.active{
          transform: rotate(90deg);
        }
      }
    }
    .sub{
      .sub-text{
        font-size: 12px/@size;font-weight: bold;padding: 4px/@size 0 4px/@size 4px/@size;
      }
      .sub-con{
        padding-bottom: 6px/@size;
        .text{
          padding-left: 12px/@size;
        }
      }
    }
    .footer{
      padding: 24px/@size 0;
      text-align: center;
      font-size: 14px/@size;
      .qr-con{
        width: 100%;
        .code-img{
          display: block;
          width: 160px/@size;
          margin: 0 auto;
        }
      }
      .text-con{
        padding: 24px/@size 0 0 0;
      }
    }
  }
}

@media all and (min-width: 1280px) { // 128 / 37.5 = 5.12
  @size: 3.413333;
  .help-con{
    background-color: #f4f4f4;
    font-size: 14px/@size;
    padding: 12px/@size;
    .top-title{
      text-align: center;line-height: 30px/@size;font-size: 18px/@size;font-weight: bold;
    }
    .img-con{
      padding: 12px/@size 0;
      .img{display: block;min-width: 80%;max-width: 100%;margin: 0 auto;}
    }
    .title{
      font-size: 16px/@size;height: 44px/@size;width: 100%;display: flex;align-items: center;
      .text{flex: 1;}
      .right{
        display: inline-flex;width: 33px/@size;height: 33px/@size;
        background: url("../../assets/help/right.png") no-repeat 50% 50%;background-size: 16px/@size 16px/@size;
        &.active{
          transform: rotate(90deg);
        }
      }
    }
    .titl-2{
      font-size: 14px/@size;font-weight: bold;height: 36px/@size;display: flex;align-items: center;
      .text{flex: 1;}
      .right{
        display: inline-flex;width: 33px/@size;height: 33px/@size;
        background: url("../../assets/help/right.png") no-repeat 50% 50%;background-size: 16px/@size 16px/@size;
        &.active{
          transform: rotate(90deg);
        }
      }
    }
    .sub{
      .sub-text{
        font-size: 12px/@size;font-weight: bold;padding: 4px/@size 0 4px/@size 4px/@size;
      }
      .sub-con{
        padding-bottom: 6px/@size;
        .text{
          padding-left: 12px/@size;
        }
      }
    }
    .footer{
      padding: 24px/@size 0;
      text-align: center;
      font-size: 14px/@size;
      .qr-con{
        width: 100%;
        .code-img{
          display: block;
          width: 160px/@size;
          margin: 0 auto;
        }
      }
      .text-con{
        padding: 24px/@size 0 0 0;
      }
    }
  }
}
</style>
